// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"46":"b7c5dd175317c3b8ece2","344":"87e72c24fb361938f62f","453":"55256ddfa45cfeba165e","544":"3c8f23cf6d1e52b21fec","567":"46adfbab15bde30565ce","671":"aaa69fed91ad9024c928","911":"c77c48ce17c9876399eb"}[chunkId] + ".js";
};